// import React from "react";
// import { Tabs } from "antd";
// import PowerBiEmbed from "./PowerBiEmbed";
// import { ToastContainer } from "react-toastify";

// const Result = () => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   const powerBiLinks = user?.powerBiLinks || [];

//   if (powerBiLinks.length === 0) {
//     return <div>No Power BI links found.</div>;
//   }

//   return (
//     <>
//       <ToastContainer />
//       <Tabs
//         defaultActiveKey="0"
//         tabPosition="top"
//         type="card"
//         style={{ padding: "1rem" }}
//       >
//         {powerBiLinks.map((report, index) => (
//           <Tabs.TabPane tab={report.title || `Report ${index + 1}`} key={index}>
//             <PowerBiEmbed link={report.link} />
//           </Tabs.TabPane>
//         ))}
//       </Tabs>
//     </>
//   );
// };

// export default Result;


import React, { useState } from "react";
import { Table } from "antd";
import { ToastContainer } from "react-toastify";
import PowerBiEmbed from "./PowerBiEmbed";
import PageHeading from "../PageHeading";
import { MdOutlineUpload } from "react-icons/md";
import { useNavigate } from "react-router-dom";


const Result = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const powerBiLinks = user?.powerBiLinks || [];
  const navigate = useNavigate();

  const [selectedReport, setSelectedReport] = useState(null);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title"
    },
    // {
    //   title: "URL",
    //   dataIndex: "link",
    //   key: "link",
    //   render: (text) => (
    //     <a href={text} target="_blank" rel="noopener noreferrer">
    //       {text}
    //     </a>
    //   )
    // },
    {
      title: "Desciption",
      dataIndex: "description",
      key: "description",
    }
  ];

  // const handleRowClick = (record) => {
  //   setSelectedReport(record);
  // };
const handleRowClick = (record, index) => {
    navigate(`/powerbi-module/${index}`, { state: record });
  };
  return (
    <>
      <ToastContainer />
      <div className='reports-section'>
       
        <div className='page-heading'>
          <h3>Special Reports</h3>
        </div>
        <Table
          dataSource={powerBiLinks}
          columns={columns}
          rowKey={(record, index) => index}
          onRow={(record, index) => ({
            onClick: () => handleRowClick(record, index),
            style: { cursor: "pointer" }
          })}
          pagination={true}
        />
      </div>
        
        {selectedReport && <PowerBiEmbed link={selectedReport.link} />}
    </>
  );
};

export default Result;
